/* JBHK 3D logo in the footer (snippets/jbhk-logo-3d.liquid).
   The theme's own model-viewer (same file as the home podium, so it is defined only once) loads only when the footer
   comes near. The logo spins in, leans toward the pointer, sways gently when the pointer rests (always on touch) and
   spins once more per click.
   Reduced motion, data saver or a failed load: the poster stays, nothing else is fetched. */
(() => {
  const box = document.querySelector('[data-jbhk-logo3d]');
  if (!box || !('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData)) return;

  const stage = box.querySelector('.jbhk-logo3d__stage');
  const near = new IntersectionObserver(([e]) => {
    if (!e.isIntersecting) return;
    near.disconnect();
    import(box.dataset.lib).then(start, () => {});
  }, { rootMargin: '600px 0px' });
  near.observe(box);

  function start() {
    // Angles in degrees. spin eases toward spinGoal: one turn in on load, one more per click.
    let spin = -360, spinGoal = 0, leanX = 0, leanY = 0, idle = 1, px = null, py = 0, moved = -1e9, last = 0, seen = false, raf = 0;
    // The GLB is meshopt-compressed; the self-hosted decoder replaces model-viewer's CDN default.
    customElements.get('model-viewer').meshoptDecoderLocation = box.dataset.decoder;
    const mv = document.createElement('model-viewer');
    // 14 m at 23.7deg: the badge fills about 85% of the 2:1 stage and stays inside it when it turns edge-on.
    const attrs = { src: box.dataset.src, 'environment-image': box.dataset.env, exposure: '2.7', 'field-of-view': '23.7deg', 'min-field-of-view': '5deg', 'camera-orbit': '0deg 90deg 14m', 'min-camera-orbit': 'auto auto 1m', 'interaction-prompt': 'none', loading: 'eager' };
    for (const k in attrs) mv.setAttribute(k, attrs[k]);
    mv.className = 'jbhk-logo3d__model';
    mv.addEventListener('load', () => {
      box.classList.add('is-ready');
      new IntersectionObserver(([e]) => {
        seen = e.isIntersecting;
        if (seen && !raf) raf = requestAnimationFrame(frame);
      }).observe(box);
    }, { once: true });
    stage.append(mv);

    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      addEventListener('pointermove', e => { px = e.clientX; py = e.clientY; moved = performance.now(); }, { passive: true });
    }
    stage.addEventListener('click', () => { if (box.classList.contains('is-ready')) spinGoal += 360; });

    const clamp = v => Math.max(-1, Math.min(1, v));
    function frame(now) {
      raf = 0;
      if (!seen) return;
      const dt = Math.min(now - last, 50) / 16.7;
      last = now;
      const ease = rate => 1 - Math.pow(1 - rate, dt);
      let tx = 0, ty = 0;
      if (px !== null) {
        const r = stage.getBoundingClientRect();
        tx = clamp((px - r.left - r.width / 2) / (innerWidth / 2));
        ty = clamp((py - r.top - r.height / 2) / (innerHeight / 2));
      }
      leanX += (tx - leanX) * ease(0.06);
      leanY += (ty - leanY) * ease(0.06);
      spin += (spinGoal - spin) * ease(0.05);
      idle += ((now - moved > 2500 ? 1 : 0) - idle) * ease(0.02);
      const t = now / 1000;
      const theta = spin - leanX * 28 + idle * Math.sin(t * 0.55) * 16;
      const phi = 90 - leanY * 12 + idle * Math.sin(t * 0.4) * 4;
      mv.cameraOrbit = `${theta}deg ${phi}deg 14m`;
      mv.jumpCameraToGoal();
      raf = requestAnimationFrame(frame);
    }
  }
})();
